/* eslint eqeqeq: 0 */
/* eslint-disable react/prop-types */ import "./App.css";
import React, { useEffect, useState } from "react";
import Community from "./components/community";
import NavBar from "./components/navbar";
import Topnews from "./components/topnews";
import Article from "./components/article";
import { XEmbed } from "react-social-media-embed";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Footer from "./components/footer";
import ArticleView from "./components/articleView";
import NoticeView from "./components/noticeView";
import Contacts from "./components/contactsPage";
// import About from './components/about';
import Gallery from "./components/gallery";
import FAQ from "./components/faq";
import { fetchTwitterPost } from "./Api";
import VideoTabs from "./components/videoTabs";
import SpinWheel from "./spinWheel";

import SurveyAdmin from "./components/survey";
import SurveyCreator from "./components/survey_creator";
import Videos from "./components/videos";
import Downloads from "./components/downloads";
import Deals from "./components/deals";
import TestPage from "./testpage";
import SurveyPageView from "./components/surveyPage";
import SurveyAnalytics from "./components/surveyAnalytics";

import TicketSurveyPageView from "./components/ticketSurvey/surveyPage";
import TicketSurveyAdmin from "./components/ticketSurvey/survey";
import TicketSurveyCreator from "./components/ticketSurvey/survey_creator";
import TicketSurveyAnalytics from "./components/ticketSurvey/surveyAnalytics";

import JobApplication from "./components/jobApplication";
import Jobs from "./components/jobs";
import Sub from "./components/sub";
import VideoShorts from "./components/videoView";
import Scholarship from "./components/scholarship";
// import SingleSlider from './components/singleSlider'
import Letter from "./components/letter";
import ProtectedRoute from "./components/ProtectedRoute";
// import ScrollToTopButton from './components/scrollToTopButton'
const baseUrl = window.location.pathname.split("/")[0];
const Home = () => {
  const [twpost, setTwpost] = useState([]);

  useEffect(() => {
    const getTwitterPost = async () => {
      try {
        // setLoading(true)
        const data = await fetchTwitterPost();
        setTwpost(data);
      } catch (error) {
        console.log(error);
      }
    };
    getTwitterPost();
  }, []);

  useEffect(() => {
    const handleIframeError = (event) => {
      const iframe = event.target;
      if (iframe) {
        const src = iframe.src;
        iframe.src = "";
        iframe.src = src; // Reload the iframe by setting the src to an empty string and then back to the original value
      }
    };

    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      iframe.addEventListener("error", handleIframeError);
    });

    return () => {
      // Clean up event listeners when the component unmounts
      iframes.forEach((iframe) => {
        iframe.removeEventListener("error", handleIframeError);
      });
    };
  }, []);

  return (
    <div>
      <NavBar title="home" />
      <Topnews />
      <Sub />

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      ></div>
      {true && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1366,
              width: "100%",
              background: "white",
              display: "flex",
              flexDirection: "row",
              minHeight: 100,
            }}
          >
            <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
              <Article />
              <VideoTabs />

              <br />
              <br />

              <div className="scrollable-div d-sm-none">
                <div style={{ width: 300, margin: 10, marginTOp: 20 }}>
                  {twpost?.length > 0 && <XEmbed url={twpost[0].tweet_id} />}
                </div>

                <div style={{ width: 300, margin: 10, marginTop: 20 }}>
                  {/* {fbpost?.length>0 &&  <FacebookEmbed url={fbpost[0].post_url} width={'100%'} />} */}
                </div>
              </div>
            </div>

            <div className="my-div" style={{ flex: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid black",
                  paddingTop: 20,
                  marginLeft: 10,
                }}
              >
                <div
                  style={{
                    padding: 5,
                    lineHeight: "20px",
                    color: "white",
                    background: "black",
                    width: 150,
                  }}
                >
                  Feeds
                </div>
              </div>
              <br />
              {twpost?.length > 0 && <XEmbed url={twpost[0].tweet_id} />}
              <br /> <br />
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://www.facebook.com/konnecthub"
              >
                <div
                  className="titlehover"
                  style={{
                    display: "flex",
                    marginLeft: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <div style={{ fontSize: 14 }}>
                    <img alt="" height={40} src={"./images/facebook.png"} />
                    Konnect Hub
                  </div>
                  <div style={{ fontSize: 14 }}>Like</div>
                </div>
              </Link>
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://twitter.com/KonnectInternet"
              >
                <div
                  className="titlehover"
                  style={{
                    display: "flex",
                    marginLeft: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <div style={{ fontSize: 14 }}>
                    <img alt="" height={40} src={"./images/twitter.png"} />
                    KonnectInternet
                  </div>
                  <div style={{ fontSize: 14 }}>Follow</div>
                </div>
              </Link>
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://www.youtube.com/@KaribuKonnect"
              >
                <div
                  className="titlehover"
                  style={{
                    display: "flex",
                    marginLeft: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <div style={{ fontSize: 14 }}>
                    <img alt="" height={40} src={"./images/youtube.png"} />
                    KaribuKonnect
                  </div>
                  <div style={{ fontSize: 14 }}>Subscribe</div>
                </div>
              </Link>
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://instagram.com/konnecthub?igshid=NTc4MTIwNjQ2YQ=="
              >
                <div
                  className="titlehover"
                  style={{
                    display: "flex",
                    marginLeft: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <div style={{ fontSize: 14 }}>
                    <img alt="" height={40} src={"./images/insta.png"} />
                    Konnect Hub
                  </div>
                  <div style={{ fontSize: 14 }}>Follow</div>
                </div>
              </Link>
              {/* <br />
              {twpost?.length > 0 && <XEmbed url={twpost[0].tweet_id} />}
              <br /> <br /> */}
              {/* {fbpost?.length>0 &&  <FacebookEmbed url={fbpost[0].post_url} width={'100%'}  />} */}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

const CommunityPage = () => {
  return (
    <div>
      <NavBar title="community" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1366,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Community />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const LetterPage = () => {
  return (
    <>
      <NavBar title="community" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div style={{ maxWidth: 1000, width: "100%" }}>
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Letter />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
const ArticleViewPage = () => {
  return (
    <>
      <NavBar title="community" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div style={{ maxWidth: 1000, width: "100%" }}>
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <ArticleView />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
const NoticeViewPage = () => {
  return (
    <>
      <NavBar title="community" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div style={{ maxWidth: 1000, width: "100%" }}>
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <NoticeView />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
const SpinWheelPage = () => {
  return (
    <div>
      <NavBar title="Spin Wheel and win" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <SpinWheel />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const GalleryPage = () => {
  return (
    <div>
      <NavBar title="gallery" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Gallery />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const FAQPage = () => {
  return (
    <div>
      <NavBar title="faq" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <FAQ />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const VideosPage = () => {
  return (
    <div>
      <NavBar title="videos" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Videos />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const ScholarshipPage = () => {
  return (
    <div>
      <NavBar title="scholarship" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Scholarship />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const DealsPage = () => {
  return (
    <div>
      <NavBar title="deals" />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Deals />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const KonnectSurveyPage = () => {
  return (
    <div>
      <SurveyAdmin />
    </div>
  );
};

const TicketKonnectSurveyPage = () => {
  return (
    <div>
      <TicketSurveyAdmin />
    </div>
  );
};
const SurveyCreatorPage = () => {
  return (
    <div>
      <SurveyCreator />
    </div>
  );
};
const TicketSurveyCreatorPage = () => {
  return (
    <div>
      <TicketSurveyCreator />
    </div>
  );
};
const DownloadsPage = () => {
  return (
    <div>
      <NavBar />
      {/* <Topnews/> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Downloads />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const JobApplicationPage = () => {
  return (
    <div>
      <NavBar />

      <JobApplication />

      <Footer />
    </div>
  );
};

const JobsPage = () => {
  return (
    <div>
      <NavBar />

      <Jobs />

      <Footer />
    </div>
  );
};
const ContactsPage = () => {
  return (
    <div>
      <NavBar />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 600,
            width: "100%",
            background: "white",
            display: "flex",
            flexDirection: "row",
            minHeight: 100,
          }}
        >
          <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <Contacts />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const App = () => {
  return (
    <div>
      <BrowserRouter>
        {/* <div> */}
        {/* <Route  path="/" element={< Navbar />} /> */}
        {/* <NavBar title='home' /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route exact path="/community" element={<CommunityPage />} />
          <Route exact path="/community/:id" element={<ArticleViewPage />} />
          <Route exact path="/notice/:id" element={<NoticeViewPage />} />
          <Route exact path="/about" element={<aboutPage />} />
          <Route exact path="/gallery" element={<GalleryPage />} />
          <Route exact path="/faq" element={<FAQPage />} />
          <Route exact path="/testpage" element={<TestPage />} />
          <Route
            exact
            path="/wheel"
            element={
              <ProtectedRoute>
                <SpinWheelPage />
              </ProtectedRoute>
            }
          />

          <Route exact path="/contact-us" element={<ContactsPage />} />
          <Route exact path="/letter/:id" element={<LetterPage />} />

          <Route exact path="/videos" element={<VideosPage />} />
          <Route exact path="/deals" element={<DealsPage />} />
          <Route exact path="/downloads" element={<DownloadsPage />} />

          <Route exact path="/survey/admin" element={<KonnectSurveyPage />} />
          <Route
            exact
            path="/survey/admin/edit/:id"
            element={<SurveyCreatorPage />}
          />
          <Route exact path="/survey/view/:id" element={<SurveyPageView />} />
          <Route
            exact
            path="/survey/admin/analytics/:id/:slug"
            element={<SurveyAnalytics />}
          />

          <Route
            exact
            path="/ticket/survey/admin"
            element={<TicketKonnectSurveyPage />}
          />
          <Route
            exact
            path="/ticket/survey/admin/edit/:id"
            element={<TicketSurveyCreatorPage />}
          />
          <Route
            exact
            path="/ticket/survey/view/:id"
            element={<TicketSurveyPageView />}
          />
          <Route
            exact
            path="/ticket/survey/view/:id/:ticket"
            element={<TicketSurveyPageView />}
          />
          <Route
            exact
            path="/ticket/survey/admin/analytics/:survey/:ticket"
            element={<TicketSurveyAnalytics />}
          />

          <Route exact path="/job/apply/:id" element={<JobApplicationPage />} />
          <Route exact path="/jobs" element={<JobsPage />} />
          <Route exact path="/verticle/videos" element={<VideoShorts />} />
          <Route
            exact
            path="/Konnect-Beyond-Limit-Scholarship-2025"
            element={<ScholarshipPage />}
          />
          <Route
            exact
            path="/not-found"
            element={
              <div style={{ textAlign: "center" }}>
                <NavBar />
                <div style={{ paddingTop: 60 }}>
                  <h1>Page Not Found</h1>
                  <br />
                  <img
                    alt="img"
                    src={baseUrl + "/images/404.webp"}
                    style={{ width: 340 }}
                  />
                </div>
                <div style={{ paddingTop: 60 }}>
                  <Footer />
                </div>
              </div>
            }
          />
          <Route
            path="*"
            element={
              <div style={{ textAlign: "center" }}>
                <NavBar />
                <div style={{ paddingTop: 60 }}>
                  <h1>Page Not Found</h1>
                  <br />
                  <img
                    alt=""
                    src={baseUrl + "/images/404.webp"}
                    style={{ width: 340 }}
                  />
                </div>
                <div style={{ paddingTop: 60 }}>
                  <Footer />
                </div>
              </div>
            }
          />
          {/*
        //} />
        */}
        </Routes>
        {/* </div> */}
      </BrowserRouter>
      {/* <ScrollToTopButton/> */}
    </div>
  );
};
export default App;
